var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/exchangerate'], function($, core, BaseCollection, ExchangeRateModel) {
  var ExchangeRateCollection;
  return ExchangeRateCollection = (function(_super) {

    __extends(ExchangeRateCollection, _super);

    function ExchangeRateCollection() {
      ExchangeRateCollection.__super__.constructor.apply(this, arguments);
    }

    ExchangeRateCollection.prototype.path = function() {
      return core.getConfig().apiPrefix + 'exchangerate.json/' + core.getCurrentClientCurrencyId();
    };

    ExchangeRateCollection.prototype.model = ExchangeRateModel;

    return ExchangeRateCollection;

  })(BaseCollection);
});
